import React, { FunctionComponent } from "react";

import { VehicleManufacturerEntry } from "../../../stores/slices/packageEditorSlice";
import { LinearProgress } from "../../../ui/LinearProgress";
import { VehicleMappingItem } from "../useVehicleMaping";
import { VehicleList } from "./VehicleList";
import { VehicleLoader } from "./VehicleLoader";

export type VehicleMappingData = {
  currentlySelected: number;
  currentlyShowing: number;
  selectNone: VoidFunction;
  selectVisible: VoidFunction;
  totalAvailable: number;
  totalSelected: number;
  vehicles: VehicleMappingItem[];
};

export const VehicleMapping: FunctionComponent<{
  criteria: string;
  data?: VehicleMappingData;
  isLoading: boolean;
  setCriteria(criteria: string): void;
  setModelsAreLoading(modelsAreLoading: boolean): void;
  setVehicleManufacturers(
    vehicleManufacturers: VehicleManufacturerEntry[]
  ): void;
  toggleVehicleManufacturerId(manufacturerId: number): void;
  toggleVehicleYearId(yearId: number): void;
  vehicleManufacturerIds: number[];
  vehicleYearIds: number[];
}> = ({
  criteria,
  data,
  isLoading,
  setCriteria,
  setModelsAreLoading,
  setVehicleManufacturers,
  toggleVehicleManufacturerId,
  toggleVehicleYearId,
  vehicleManufacturerIds,
  vehicleYearIds,
}) => {
  return (
    <>
      {isLoading && <LinearProgress className="mx-4" />}
      {!isLoading && !data?.totalAvailable && (
        <VehicleLoader
          setModelsAreLoading={setModelsAreLoading}
          setVehicleManufacturers={setVehicleManufacturers}
          toggleVehicleManufacturerId={toggleVehicleManufacturerId}
          toggleVehicleYearId={toggleVehicleYearId}
          vehicleManufacturerIds={vehicleManufacturerIds}
          vehicleYearIds={vehicleYearIds}
        />
      )}
      {!isLoading && !!data?.totalAvailable && (
        <VehicleList
          criteria={criteria}
          data={data}
          setCriteria={setCriteria}
        />
      )}
    </>
  );
};
